<nz-select appendToSelect [nzShowArrow]="true" class="w-100 custom-select" [ngClass]="{'error-select': isErrorSelect}" [nzMode]="csMode"
           [nzPlaceHolder]="csPlaceHolder" [nzShowSearch]="csShowSearch" [nz-tooltip]="selectedValues?.length ? tooltipMoreSelectedTpl : ''"
           [nzAutoClearSearchValue]="false" [nzServerSearch]="true" [nzDropdownMatchSelectWidth]="csDropdownMatchSelectWidth" [nzMaxTagPlaceholder]="tagPlaceHolder"
           [nzDisabled]="csDisable" [(ngModel)]="controlValue" (nzOnSearch)="onSearch($event)" [nzNotFoundContent]="noData" [nzCustomTemplate]="defaultTemplate"
            [nzAllowClear]="csAllowClear" (nzScrollToBottom)="loadMorePage()" (ngModelChange)="onChangeSelect($event)" (nzOpenChange)="openChange($event)"
            [nzMaxTagCount]="csMaxTagCount! || 1" [nzLoading]="isLoading"  #nzSelectRef [nzDropdownRender]="options?.length ? csDropdownRenderTpl || renderTemplate : null">
  <nz-option *ngIf="options?.length && csMode == 'multiple' && keywordSearch === ''"></nz-option>
  <ng-container *ngFor="let item of options" [ngTemplateOutlet]="optionTpl" [ngTemplateOutletContext]="{item: item, level: 0}"></ng-container>
  <ng-template #optionTpl let-item="item" let-isChild="isChild" let-hide="hide" let-level="level">
    <nz-option [nzHide]="hide"
               [nzValue]="item.value" [nzLabel]="(item.label || item.labelHtml) | translate" nzCustomContent [nzDisabled]="item?.isDisable">
      <div [class.option-child]="isChild" class="d-flex" [ngStyle]="{'padding-left': isChild && level ? (25 * level) - 18 + 'px' : 'auto'}" >
        <label *ngIf="csMode == 'multiple'" nz-checkbox class="me-1" (nzCheckedChange)="changeCheckBox($event, item)" [(ngModel)]="item.itemChecked" [nzDisabled]="item?.isDisable"></label>
        <div class="d-flex justify-content-between w-100" *ngIf="csIsMultiLevel">
          <a (click)="nextLevel(item)" class="action" *ngIf="!isLazyLoadTree ? item?.children?.length : item?.isHasChildren">
            <i class="pe-1" nzType="caret-down" [nzRotate]="item.expanded ? 0 : -90" nz-icon nzTheme="outline" ></i>
          </a>

          <!-- // vẽ icon -->
          <!-- <div *ngIf="isShowUserIcon"> -->
            <span class="css_icon" *ngIf="isShowUserIcon && !item?.image" [innerHtml]="getName(item.label)"></span>
            <nz-avatar *ngIf="isShowUserIcon && item?.image" [nzSrc]="item?.image"></nz-avatar>
          <!-- </div> -->

          <div class="label-option" [class.no-icon-expand]="!isLazyLoadTree ? !item?.children?.length : !item?.isHasChildren" [innerHtml]="(item.labelHtml | translate) || (item.label | translate | vssUiHighlightText : keywordSearch : {class: 'text-high-light'})" (click)="selectItem(item)"></div>
        </div>
        <div *ngIf="!csIsMultiLevel">
          <div [ngSwitch]="mode">
            <div *ngSwitchCase="'status'">
              <nz-tag class="status-tag" [nzColor]="item.value ? 'success' : 'default'">
                <span class="dot"
                  [ngClass]="{
                    'dot-success': item.value,
                    'dot-default': !item.value
                  }"
                >
                </span>
                <span [innerHtml]="(item.labelHtml | translate)  || (item.label | translate | vssUiHighlightText : keywordSearch : {class: 'text-high-light'})"></span>
              </nz-tag>
            </div>
            <span *ngSwitchDefault [innerHtml]="(item.labelHtml | translate) || (item.label | translate | vssUiHighlightText : keywordSearch : {class: 'text-high-light'})"></span>
          </div>
        </div>
      </div>
    </nz-option>
    <ng-container *ngFor="let child of item?.children" [ngTemplateOutlet]="optionTpl" [ngTemplateOutletContext]="{item: child, isChild: true, hide: hide || !item.expanded, level: level + 1}"></ng-container>
<!--    <nz-option-group [nzLabel]="labelOptionGroup" *ngIf="item.expanded">-->
<!--      <ng-template #labelOptionGroup><span class="active" [innerHTML]="item.labelHtml || item.label"></span></ng-template>-->
<!--      <ng-container *ngFor="let child of item?.children" [ngTemplateOutlet]="optionTpl" [ngTemplateOutletContext]="{item: child}"></ng-container>-->
<!--    </nz-option-group>-->
  </ng-template>
  <ng-container *ngFor="let item of selectedValues">
    <nz-option [nzValue]="item.value" [nzLabel]="(item.label | translate) || (item.labelHtml | translate)" nzCustomContent [nzHide]="options | includesObject : item : 'value' : 'children'">
      <span [innerHtml]="(item.labelHtml | translate) || (item.label | translate)" (click)="selectItem(item)"></span>
    </nz-option>
  </ng-container>
  <ng-template #tagPlaceHolder let-selectedList><div title="">+ {{ csMaxTagCount! ? uniqValue(selectedValues).length - csMaxTagCount! : uniqValue(selectedValues).length - 1 }}...</div></ng-template>
  <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
    <i nz-icon nzType="loading" class="loading-icon" aria-hidden="true"></i>
    Loading Data...
  </nz-option>
</nz-select>
<ng-template #defaultTemplate let-selected>
  <div class="cs-select-scroll-item-selected">
    <span class="text-muted" *ngIf="suffixLabelSelected">{{ suffixLabelSelected | translate}}</span>
    {{selected.nzLabel | translate}}
  </div>
</ng-template>
<ng-template #noData>
  <nz-empty nzNotFoundImage="/assets/icons/empty.svg" [nzNotFoundContent]="contentTpl"></nz-empty>
</ng-template>
<ng-template #contentTpl>
  <span>
    {{'BASE.NO_DATA_2' | translate}}
  </span>
</ng-template>
<ng-template #tooltipMoreSelectedTpl>
  <div *ngIf="csMode == 'multiple'">
    <ul class="list-item-tooltip">
      <li  *ngFor="let item of selectedValuesAsync"><span [innerHtml]="(item.labelHtml | translate) || (item.label | translate)"></span></li>
    </ul>
  </div>
  <ng-container *ngIf="csMode != 'multiple'">
    <ng-container *ngFor="let item of selectedValuesAsync">
      <div>
        <span [innerHtml]="(item.labelHtml | translate) || (item.label | translate)"></span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #renderTemplate>
  <div *ngIf="options?.length && csMode == 'multiple' && keywordSearch === ''" class="d-flex" style="position: absolute; top: 0; padding: 5px 12px; min-height: 32px; width: 100%; background-color: white; border: solid 1px var(--border-color-1);">
    <label nz-checkbox class="me-1" (nzCheckedChange)="changeCheckAll($event)" [(ngModel)]="selectAllChecked" [nzDisabled]="disableSelectAll"></label>
    <span [ngStyle]="{'font-weight': selectAllChecked ? 'bold' : 'unset', 'cursor': disableSelectAll ? 'not-allowed' : 'pointer'}" (click)="changeCheckAll(!selectAllChecked)">{{'BASE.CHOISE_ALL' | translate}}</span>
  </div>
</ng-template>
